import React from "react";
type RiskScore = {
  value: number | null;
  type: "low" | "medium" | "high" | "none";
};

type Props = {
  riskScore: RiskScore;
};

const riskIconMap: Record<RiskScore["type"], string> = {
  high: "❗️",
  medium: "⚠️",
  low: "✅",
  none: "",
};

const RiskScoreCell: React.FC<Props> = ({ riskScore }) => {
  const { value, type } = riskScore;
  if (type === "none" || value === null) {
    return <span>-</span>;
  }
  return (
    <span style={{ padding: "1px" }}>
      {value} <span style={{ fontSize: "18px" }}>{riskIconMap[type]}</span>
    </span>
  );
};

export default RiskScoreCell;
